export default {
  state: {
    title: '',
    content: ''
  },
  mutations: {
    SET_TITLE (state, title) {
      state.title = title
    },
    SET_CONTENT (state, content) {
      state.content = content
    }
  },
  actions: {
    fetchNotification ({
      commit
    }, data) {
      commit('SET_TITLE', data.title)
      commit('SET_CONTENT', data.content)
    }
  },
  getters: {

  }
}
